module.exports = require("superagent");


//////////////////
// WEBPACK FOOTER
// external "superagent"
// module id = 240
// module chunks = 0